var exports = {
  "h": "confirmationContent__6jo4YY",
  "E": "confirmationList__izXbA4",
};

module.exports = exports;
